import { render } from "./BallotStatus.vue?vue&type=template&id=55678e84"
import script from "./BallotStatus.vue?vue&type=script&lang=js"
export * from "./BallotStatus.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__